module.exports = __webpack_public_path__ + "img/img3.059e9646.png";